// package.json lives at the app root, outside `src/`, so the `~/` alias can't reach it.
// eslint-disable-next-line no-restricted-imports
import { name as appName, version } from '../../../package.json';

const env = import.meta.env.VITE_NODE_ENV || 'development';
const appUrl = import.meta.env.VITE_APP_URL;

// Depends on `VITE_API_URL` being defined in the environment during build.
// This is defined in the Gitlab env vars during CI, or in a `.env` file during development.
const host = import.meta.env.VITE_API_URL;

let logLevel = 'debug';
if (import.meta.env.VITE_LOG_LEVEL) logLevel = import.meta.env.VITE_LOG_LEVEL;
if (env === 'production') logLevel = 'info';
if (env === 'test') logLevel = 'silent';

const defaultLang = 'en-ca';

// If adding new supported languages, be sure to also load the corresponding
// datetime locales in the `/src/tools/datetime.js` module.
const supportedLanguages = ['en-ca', 'fr-ca', 'es-es'];

// Default date format for consistent display purposes.
// Uses year-month-day for optimal sorting and comprehension.
const defaultDateFormat = 'yyyy-MM-dd';

const maxUploadSize = 1000 * 600; // 600 KB

// System features
const enableI18nLog = import.meta.env.VITE_DEBUG_I18N === 'true' && env !== 'production' && env !== 'test';
const enableReduxDevMiddleware =
  import.meta.env.VITE_REDUX_DEV_MIDDLEWARE === 'true' && env !== 'production' && env !== 'test';
const enableReduxLog = import.meta.env.VITE_DEBUG_REDUX === 'true' && env !== 'production' && env !== 'test';

// OpenFeature / DevCycle
const devCycleClientSdkKey = import.meta.env.VITE_DEVCYCLE_CLIENT_SDK_KEY;
const devCycleDebuggerEnabled = import.meta.env.VITE_DEVCYCLE_DEBUGGER_ENABLED === 'true';

// DataDog version
const datadogVersion = import.meta.env.VITE_SHA ?? version;

export {
  appName,
  appUrl,
  defaultDateFormat,
  defaultLang,
  enableI18nLog,
  enableReduxDevMiddleware,
  enableReduxLog,
  env,
  host,
  logLevel,
  maxUploadSize,
  supportedLanguages,
  version,
  datadogVersion,
  devCycleClientSdkKey,
  devCycleDebuggerEnabled,
};
